import React from 'react';
import _ from 'underscore';

import {graphQLToREST} from 'graphql-client/declarative-translations/external/translate';
import AddRequestSampleRowModal from 'requests/samples-table/AddRequestSampleRowModal';
import AbsoluteDropdownContainer from 'ui-library/AbsoluteDropdownContainer';
import Menu from 'ui-library/menus/Menu';
import Option from 'ui-library/menus/Option';
import * as RichObjectTable from 'ui-library/RichObjectTable';
import runModal from 'ui-library/runModal';
import {PreparedUISampleGroup} from 'workflows/samples/PreparedSampleGroupConstants';

import {SampleGroupSchemaGraphQL} from '../../../graphql-fragments/requests/schemas/__generated/SampleGroupSchemaGraphQL';

interface RequestSampleTableAddMenuProps {
  onAddSampleGroup: (sampleGroup: PreparedUISampleGroup) => void;
  onImportFromGrid: () => void;
  onImportFromSpreadsheet: () => void;
  sampleGroupSchema: SampleGroupSchemaGraphQL;
  shouldShowImportFromGrid: boolean;
}

interface State {
  open: boolean;
}

class RequestSampleTableAddMenu extends React.Component<RequestSampleTableAddMenuProps, State> {
  override state: State = {open: false};

  _getOptions(): Array<JSX.Element> {
    return _.compact([
      <Option
        key="add-row"
        value="add-row"
        icon="compose"
        onSelect={async () => {
          const sampleGroup = await runModal(AddRequestSampleRowModal, {
            sampleGroupSchema: graphQLToREST('SampleGroupSchema', this.props.sampleGroupSchema),
          });
          if (!sampleGroup) {
            return;
          }
          this.props.onAddSampleGroup(sampleGroup);
        }}
      >
        Add row
      </Option>,
      this.props.shouldShowImportFromGrid ? (
        <Option
          key="import-from-grid"
          value="import-from-grid"
          icon="well-plate"
          onSelect={this.props.onImportFromGrid}
        >
          Import from plate or box
        </Option>
      ) : null,
      <Option
        key="import-spreadsheet"
        value="import-spreadsheet"
        icon="upload"
        onSelect={this.props.onImportFromSpreadsheet}
      >
        Import from spreadsheet
      </Option>,
    ]);
  }

  override render(): JSX.Element {
    return (
      <AbsoluteDropdownContainer
        menu={
          <Menu height={Menu.HEIGHTS.MEDIUM} width={Menu.WIDTHS.XLARGE}>
            {this._getOptions()}
          </Menu>
        }
        onRequestClose={() => {
          this.setState({open: false});
        }}
        open={this.state.open}
        shouldCloseOnInsideClick={true}
      >
        <RichObjectTable.AddButton
          className="u-mini-spacing-left u-mini-spacing-right"
          onClick={() => {
            this.setState({open: true});
          }}
        />
      </AbsoluteDropdownContainer>
    );
  }
}

export default RequestSampleTableAddMenu;
